import { ReactNode } from "react";
import { MosaicTrafficLightClass } from "../traffic-lights/MosaicTrafficLightClass";
import { AitLocationBodyRowGroup, AitLocationHeader } from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupDeletedItemTrafficLightProps {
  location: AitLocationHeader | AitLocationBodyRowGroup;
}

/**
 * Render a deleted-item traffic light for a row group when present.
 *
 * @param props - Component props
 * @param props.location - The header or body row-group location
 */
export const AitRowGroupDeletedItemTrafficLight = ({
  location,
}: AitRowGroupDeletedItemTrafficLightProps): ReactNode => {
  const { state } = useTableContext();
  const deletedItemTrafficLight =
    (state?.processedTableData?.changedRowGroups?.filter(
      (drg) =>
        drg.coreTrafficLight === "RedError" &&
        drg.idAfterTrafficLightIsShown === location.rowGroupId,
    ).length ?? 0) > 0
      ? "RedError"
      : "BlankNotEvaluated";

  return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated"
    ? new MosaicTrafficLightClass(deletedItemTrafficLight, "-8px", "40px").element
    : null;
};

AitRowGroupDeletedItemTrafficLight.displayName = "AitRowGroupDeletedItemTrafficLight";
